export default __webpack_public_path__ + "static/serv-47ab302d613d75d67c63902c97dc9958.svg";